import { render, staticRenderFns } from "./ReservationListItem.vue?vue&type=template&id=5200e0e1&scoped=true&"
import script from "./ReservationListItem.vue?vue&type=script&lang=js&"
export * from "./ReservationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5200e0e1",
  null
  
)

export default component.exports